// extracted by mini-css-extract-plugin
module.exports = {"no-scroll":"cover_no-scroll__3Yc5Y"};